export default {"src":"/_next/static/media/duration.9a168bc9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};